<template>
  <div id="main">
    <div class="container">
      <div class="form">
        <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
          <el-form-item label="上传营业执照或者带有企业名称的办公环境照片" prop="bl_image">
            <input type="file" accept="image/*" style="display: none;" id="fileElem" @change="handleFiles" />
            <img v-show="srcLicense" :src="srcLicense" class="avatar fileSelect" />
            <i v-show="!srcLicense" class="el-icon-plus avatar-uploader-icon fileSelect" :class="icon ? 'el-icon-loading' : ''"></i>
          </el-form-item>
          <!-- <el-form-item>
            合作学校：
            <el-select v-model="cooperation_school" :disabled="is_invited" filterable placeholder="请选择">
              <el-option v-for="item in cooperation_school_list" :key="item.id" :label="item.fdName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item>
            <button class="next" v-show="!icon" @click.prevent="next()">下一步</button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import baseUrl from '../../api/baseUrl';
import axios from 'axios';
import vconsole from 'vconsole';

export default {
  data() {
    return {
      cooperation_school_list: [],
      cooperation_school: '',
      is_invited: false,
      ruleForm: {},
      srcLicense: '',
      icon: false,
    };
  },
  mounted() {
    // new vconsole()

    // this.get_school_list()
    this.getLicense();

    var fileSelect0 = document.getElementsByClassName('fileSelect')[0],
      fileSelect1 = document.getElementsByClassName('fileSelect')[1],
      fileElem = document.getElementById('fileElem');

    fileSelect0.addEventListener(
      'click',
      function (e) {
        if (fileElem) {
          fileElem.click(); // jQuery可以使用 trigger()
        }
        e.preventDefault(); // prevent navigation to "#"
      },
      false
    );
    fileSelect1.addEventListener(
      'click',
      function (e) {
        if (fileElem) {
          fileElem.click(); // jQuery可以使用 trigger()
        }
        e.preventDefault(); // prevent navigation to "#"
      },
      false
    );
  },
  methods: {
    // 获取营业执照
    async getLicense() {
      let res = await this.$api.info.getLicense();
      if (res.code === 0) {
        this.srcLicense = res.data;
      }
    },
    handleFiles(e) {
      if (e.target.files.length === 0) {
        return;
      }

      this.srcLicense = '';
      this.icon = true;
      let that = this;
      var file = e.target.files[0]; //获取图片资源
      let maxSize = 6 * 1024 * 1204;
      let fileInput = document.getElementById('fileElem');

      // 只选择图片文件
      if (!file.type.match('image.*')) {
        this.$message.error('请上传图片！');
        fileInput.value = '';
        return false;
      }

      if (file.size > maxSize) {
        this.$message.error('图片大小不能超过6M！');
        fileInput.value = '';
        return;
      }

      var reader = new FileReader();
      reader.readAsDataURL(file); // 读取文件

      reader.onload = function () {
        if (file.size <= 2 * 1024 * 1024) {
          that.uploadLicense(file, this.result);
        } else {
          var result = this.result;
          let img = new Image();
          img.src = result;

          img.onload = function () {
            var canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            canvas.width = 300;
            canvas.height = 300;
            ctx.drawImage(this, 0, 0, 300, 300);
            canvas.toBlob(function (blob) {
              console.log(`压缩后图片大小：${blob.size / 1024 / 1024}M`);
              that.uploadLicense(blob, result);
            });
          };
        }
      };
    },
    async uploadLicense(fileData, base64) {
      let formData = new FormData();
      formData.append('photo', fileData);
      formData.append('type', 'bl_image');

      try {
        let res = await axios.post(baseUrl + 'api/enterprise/business/pic/add', formData, {
          withCredentials: true,
        });

        if (res.data.code === 0) {
          this.srcLicense = base64;
          this.$message.success('上传成功');
        } else {
          this.getLicense();
          this.$message.error(res.data.msg);
        }
      } catch (error) {
        this.$message.error(error.message);
        this.getLicense();
      } finally {
        this.icon = false;
      }
    },
    // 合作学校
    async get_school_list() {
      let res = await this.$api.school.getSchool(1, 1100);
      if (res.code === 0) {
        this.cooperation_school_list = res.data.items;
        this.cooperation_school = Number(this.$route.params.school_id);
        this.is_invited = true;
      }
    },
    // 下一步
    async next() {
      let params = {
        school_id: this.$route.params.school_id,
        source: this.$route.query.register_source,
        student_id: this.$route.query.student_id,
      };
      let res = await this.$api.school.applyAdd(params);
      if (res.code !== 0) {
        this.$message.error(res.msg);
        return;
      }
      let register_source = this.$route.query.register_source;
      this.$router.push({
        path: '/job',
        query: {
          relationId: res.data.id,
          studentId: this.$route.query.student_id,
          schoolId: this.$route.params.school_id,
          register_source
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/css/base.scss';

#main {
  width: 100vw;
  height: 100%;
  min-height: 600px;
  margin: 0;
  padding-top: 50px;
  color: #505050;
  font-size: 14px;
  background: url('../../assets/img/bg.png') no-repeat;
  background-size: 100%;
  .container {
    width: 90%;
    margin: 0 auto;
    margin-bottom: 30px;
    border-radius: vw(23);
    background: #fff;
    .form {
      margin-top: 20px;
      padding: 20px 10px 30px;
      .el-select {
        width: 100%;
      }
      .el-form-item__label {
        font-size: 1em;
        font-weight: bold;
        color: rgb(16, 68, 110);
        text-align: left !important;
        width: 80px !important;
        float: none;
      }
      .el-form-item__content {
        margin-left: 0px !important;
      }
      .next {
        width: 100%;
        height: vw(67);
        text-align: center;
        line-height: vw(67);
        border-radius: vw(33);
        background: #66aef4;
        color: #fff;
        font-size: vw(28);
        border: none;
        outline: none;
      }
    }
  }
}
hr {
  background: #c3c9d0;
  height: 1px;
  border: none;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  clear: both;
  display: block;
  width: 60%;
}

@media screen and (min-width: 500px) {
  #main {
    background-size: 100% 500px;
    .container {
      width: 400px;
      .avatar {
        width: 200px;
        height: 200px;
      }
      .form {
        .next {
          height: 50px;
          line-height: 50px;
          font-size: 18px;
        }
      }
    }
  }
}
</style>